// extracted by mini-css-extract-plugin
module.exports = {"iconHandler":"style_iconHandler__1SqcI","list":"style_list__V29xj"};